import { useLiveQuery } from "dexie-react-hooks"

import type { LiveQueryResult } from "../../types"
import { getSession, type SessionLocal } from "./session"

export function useSessionDetail(sessionId: string): LiveQueryResult<SessionLocal> {
  return useLiveQuery(async () => ({ data: await getSession(sessionId), isLoading: false }), [sessionId], {
    data: undefined,
    isLoading: true,
  })
}

// Returns the session when the consent screen was seen locally but not yet synced to the backend
export function usePendingConsentSync(sessionId: string): LiveQueryResult<SessionLocal> {
  return useLiveQuery(
    async () => {
      const session = await getSession(sessionId)
      const pending = session?.consentScreenSeenAt && !session.consentScreenSyncedAt ? session : undefined
      return { data: pending, isLoading: false }
    },
    [sessionId],
    { data: undefined, isLoading: true },
  )
}
